import { render, staticRenderFns } from "./WeightedScoresPage.vue?vue&type=template&id=33e31588"
import script from "./WeightedScoresPage.vue?vue&type=script&lang=ts"
export * from "./WeightedScoresPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports